import React from "react";
import { MEDIA } from "../../mock";
import { Newspaper, Tv, Edit3 } from "lucide-react";
import { SectionTitle } from "./About";

export default function Media() {
  return (
    <section className="scroll-smooth-section py-24 bg-cream/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle
          kicker="Press · Television · Editorial"
          title="A familiar voice on Kerala's media landscape"
          subtitle="Columnist, commentator and editor across decades — making complex medicine accessible to ordinary readers."
        />

        <div className="mt-12 grid lg:grid-cols-3 gap-6">
          <div className="bg-ivory rounded-2xl p-6 border border-stone-200/60 lift">
            <Newspaper className="w-7 h-7 text-emerald-deep" />
            <div className="font-display text-xl text-emerald-deep mt-3">Newspapers</div>
            <p className="text-xs uppercase tracking-widest text-gold mt-1">Columnist</p>
            <ul className="mt-4 space-y-2">
              {MEDIA.newspapers.map(n => (
                <li key={n} className="flex items-center gap-2 text-stone-700">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold" /> {n}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-emerald-deep rounded-2xl p-6 lift text-ivory">
            <Tv className="w-7 h-7 text-gold" />
            <div className="font-display text-xl mt-3">Television</div>
            <p className="text-xs uppercase tracking-widest text-gold mt-1">Medical Talks</p>
            <ul className="mt-4 grid grid-cols-2 gap-y-2">
              {MEDIA.channels.map(c => (
                <li key={c} className="flex items-center gap-2 text-ivory/90 text-sm">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold" /> {c}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-ivory rounded-2xl p-6 border border-stone-200/60 lift">
            <Edit3 className="w-7 h-7 text-emerald-deep" />
            <div className="font-display text-xl text-emerald-deep mt-3">Editorial Roles</div>
            <p className="text-xs uppercase tracking-widest text-gold mt-1">Currently</p>
            <ul className="mt-4 space-y-3">
              {MEDIA.editor.map((e, i) => (
                <li key={i} className="border-l-2 border-gold pl-3">
                  <div className="text-[11px] uppercase tracking-widest text-emerald-deep">{e.role}</div>
                  <div className="text-stone-800 text-sm">{e.title}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
